<template>
  <div class="flex flex-row justify-between p-4 fixed w-full top-0 left-0 bg-white z-10">
    <div class="w-1/3">
      <span class="cursor-pointer hover:underline" v-on:click="$router.go(-1)">Back</span>
    </div>
    <div class="w-1/3 text-center">
      <span v-if="parent"><router-link :to="parent.path">{{ parent.title }}</router-link> → </span>
      <span>{{ title }}</span>
    </div>
    <div class="w-1/3 text-right">
      <span v-if="link" class="cursor-pointer hover:underline" v-on:click="$router.push(link.path)">{{ link.label }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageHeader',

  props: ['parent', 'title', 'link'],
}
</script>

<style scoped lang="stylus">
</style>
